import { FormAction } from "../../store/incident/reducer";
import { TabOptions } from "../../types/fieldInstance.interface";

export async function updateValue(
  args: any[],
  func: (...args: any[]) => void
): Promise<void> {
  return new Promise<void>((resolve) => {
    func(...args);
    resolve();
  });
}

export function setFormState(
  formId: string,
  updateForm: (formId: string, payload: FormAction) => void
) {
  return (payload: FormAction) => {
    updateForm(formId, payload);
  };
}

export function doesUrlEndWith(url: string, substring: any) {
  const parts = url.split("/");
  const lastPart = parts[parts.length - 1];
  const stageParts = lastPart.split("?");
  const stagePath = stageParts[0];
  return stagePath === substring;
}

export function updateFormStateOnClick(
  setFormState: (payload: FormAction) => void
) {
  return (path: string, label: TabOptions) => {
    // Merge just this tab's visited flag so we don't overwrite validity that a
    // parallel revalidation set; clickedStage is a plain form-state field.
    setFormState({
      type: "MERGE_TAB_STATE",
      payload: { [label]: { visited: true } },
    });
    setFormState({
      type: "UPDATE_FORM_STATE",
      payload: { clickedStage: path },
    });
  };
}

export async function handleLinkClick(
  path: string,
  updateFormStateOnClick: (path: string, label: TabOptions) => void,
  navigate: (x: string) => void,
  label: string,
  shouldShowPrompt: boolean,
  setFormState: (payload: FormAction) => void,
  isNotFormTab: boolean
) {
  !isNotFormTab && (await updateValue([path, label], updateFormStateOnClick));
  if (shouldShowPrompt && isNotFormTab) {
    setFormState({
      type: "UPDATE_FORM_STATE",
      payload: {
        showPrompt: true,
        exitLink: label,
      },
    });
  } else {
    navigate(path);
  }
}

export async function handleLogoClick(
  navigate: (x: string) => void,
  setFormState: (payload: FormAction) => void,
  shouldShowPrompt: boolean,
  returnTo: string | null = null
) {
  if (shouldShowPrompt) {
    setFormState({
      type: "UPDATE_FORM_STATE",
      payload: {
        showPrompt: true,
      },
    });
  } else {
    await updateValue(
      [
        {
          type: "UPDATE_FORM_STATE",
          payload: {
            shouldResetForm: true,
          },
        },
      ],
      setFormState
    );
    navigate(returnTo ?? "/");
  }
}

export function getDraftId(
  isIncidentDraft: boolean,
  formId: string,
  draftId: string | undefined
): string {
  if (isIncidentDraft && !formId.includes("-")) {
    return formId;
  } else if (isIncidentDraft) {
    return draftId ?? "";
  }
  return "";
}
